import { ContainerBase } from '../../../core/base/container-base';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as customer from '../../actions/customer'
import * as user from '../../actions/user'
import * as fromAuth from '../../reducers'
import * as fromCustomer from '../../reducers/customer'
import { Customer } from '../../../core/models/customer';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PageRoutingService } from '../../../core/services/page-routing.service';


@Component({
  selector: 'app-customer-selection-container',
  templateUrl: './template.html'
})
export class CustomerSelectionContainer extends ContainerBase implements OnInit, OnDestroy {
  customers$: Observable<Customer[]>
  customerSelected$: Observable<boolean>
  isLoading$: Observable<boolean>

  constructor(private store: Store<fromCustomer.State>,
              private pageRoutingSvc: PageRoutingService) {
    super()
    this.pageRoutingSvc.breadcrumbsStatus = false
  }

  ngOnInit() {
    this.store.dispatch(new customer.Get())
    this.customers$ = this.store.pipe(select(fromAuth.getCustomersList), takeUntil(this.destroyed$))
    this.customerSelected$ = this.store.pipe(select(fromAuth.isCustomerSelected), takeUntil(this.destroyed$))
    this.isLoading$ = this.store.pipe(select(fromAuth.customersIsLoading), takeUntil(this.destroyed$))
  }

  ngOnDestroy() {
    this.pageRoutingSvc.breadcrumbsStatus = true
  }

  expand() {
    this.store.dispatch(new customer.Expand())
  }

  search(searchTerm: string) {
    searchTerm.length
      ? this.store.dispatch(new customer.Search(searchTerm))
      : this.store.dispatch(new customer.Get())
  }

  select(customer: Customer) {
    this.store.dispatch(new user.SetCustomer(customer._id))
  }
}
